import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/accounts')({
  component: () => <div>Hello /_app/accounts!</div>,
});
